var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Menu from "./../info/termsAndConditions/shared/Menu";
import Iframes from "./Iframes";
var TermsAndConditions = function (props) {
    return (_jsx(Fragment, { children: _jsxs("div", __assign({ className: "content" }, { children: [_jsxs(Helmet, { children: [_jsxs("title", { children: ["\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u0441\u043A\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 ", window.COMPANY_NAME] }), _jsx("meta", { name: "description", content: "\u041E\u0437\u043D\u0430\u043A\u043E\u043C\u044C\u0442\u0435\u0441\u044C \u0441 \u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u043F\u0440\u0438\u0435\u043C\u0430 \u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u0441\u043A\u0438\u0445 \u0441\u0442\u0430\u0432\u043E\u043A \u0438 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0432 \u0411\u041A \u00AB".concat(window.COMPANY_NAME, "\u00BB.") })] }), _jsxs("div", __assign({ className: "blc_faq" }, { children: [_jsx(Menu, {}), _jsx(Iframes, { contentPath: "terms" })] }))] })) }));
};
export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/components/staticContent/TermsAndConditions.jsx